// Class: starling.text.BitmapCharLocation

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;
function openfl__$Vector_Vector_$Impl_$() {return require("./../../openfl/_Vector/Vector_Impl_");}

// Constructor

var BitmapCharLocation = function(char) {
	this.init(char);
}

// Meta

BitmapCharLocation.__name__ = "starling.text.BitmapCharLocation";
BitmapCharLocation.__isInterface__ = false;
BitmapCharLocation.prototype = {
	init: function(char) {
		this.char = char;
		return this;
	}
};
BitmapCharLocation.prototype.__class__ = BitmapCharLocation.prototype.constructor = $hxClasses["starling.text.BitmapCharLocation"] = BitmapCharLocation;

// Init



// Statics

BitmapCharLocation.instanceFromPool = function(char) {
	var instance = BitmapCharLocation.sInstancePool.length > 0 ? (openfl__$Vector_Vector_$Impl_$().default).pop(BitmapCharLocation.sInstancePool) : new BitmapCharLocation(char);
	instance.init(char);
	(openfl__$Vector_Vector_$Impl_$().default).set(BitmapCharLocation.sInstanceLoan,BitmapCharLocation.sInstanceLoan.length,instance);
	return instance;
}
BitmapCharLocation.vectorFromPool = function() {
	var vector = BitmapCharLocation.sVectorPool.length > 0 ? BitmapCharLocation.sVectorPool.pop() : (openfl__$Vector_Vector_$Impl_$().default)._new();
	vector.length = 0;
	BitmapCharLocation.sVectorLoan[BitmapCharLocation.sVectorLoan.length] = vector;
	return vector;
}
BitmapCharLocation.rechargePool = function() {
	var instance;
	var vector;
	while(BitmapCharLocation.sInstanceLoan.length > 0) {
		instance = (openfl__$Vector_Vector_$Impl_$().default).pop(BitmapCharLocation.sInstanceLoan);
		instance.char = null;
		(openfl__$Vector_Vector_$Impl_$().default).set(BitmapCharLocation.sInstancePool,BitmapCharLocation.sInstancePool.length,instance);
	}
	while(BitmapCharLocation.sVectorLoan.length > 0) {
		vector = BitmapCharLocation.sVectorLoan.pop();
		vector.length = 0;
		BitmapCharLocation.sVectorPool[BitmapCharLocation.sVectorPool.length] = vector;
	}
}
BitmapCharLocation.sInstancePool = (openfl__$Vector_Vector_$Impl_$().default)._new()
BitmapCharLocation.sVectorPool = []
BitmapCharLocation.sInstanceLoan = (openfl__$Vector_Vector_$Impl_$().default)._new()
BitmapCharLocation.sVectorLoan = []

// Export

exports.default = BitmapCharLocation;